import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseProductGroup() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName) {
      enqueueSnackbar("لطفا اطلاعات گروه محصول را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getGroupList = (search, callback, bool) => {
    let myPC = {
      parentID: "",
      groupID: "",
    };
    MyAxios.get(`Admin_ProductGroups?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllGroupList = (search, callback) => {
    let myPC = {
      parentID: "",
      groupID: "",
      pageCount: 1,
    };

    MyAxios.get(`Admin_ProductGroups?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getGroupByID = (id, callback) => {
    MyAxios.get(`Admin_ProductGroups/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductGroups`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه محصول با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductGroups`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه محصول با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteGroup = (id, callback) => {
    const data = new FormData();
    data.append("ProductGroupID", id);
    MyAxios.delete(`Admin_ProductGroups`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه محصول با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addRelatedGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductGroups/related`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گروه مرتبط با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteRelatedGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.delete(`Admin_ProductGroups/related`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("گروه مرتبط با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const getSteps = (Steps) => {
    let steps = Steps ? Steps : undefined;

    if (steps) {
      return steps.map((s) => parseInt(s));
    }
    return steps;
  };

  const removeLastSteps = (Step) => {
    let steps = getSteps(Step);
    steps.pop();
    return steps;
  };

  const addToSteps = (Step, id) => {
    let steps = getSteps(Step) ? getSteps(Step) : [];
    steps.push(id);
    return steps;
  };

  return {
    getGroupList,
    getGroupByID,
    validate,
    updateGroup,
    addGroup,
    deleteGroup,
    getAllGroupList,
    getSteps,
    removeLastSteps,
    addToSteps,
    addRelatedGroup,
    deleteRelatedGroup,
  };
}
